/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */

import { useEffect } from 'react';
import mbpUtil from 'mbp-api-util';
import { useAccertifyContext } from './AccertifyContext';
import { registeredCallBackMethod } from '../../../../../../../helpers/common/accertify';

const AccertifyScript = () => {
    const DATA_COLLECTOR_URL = mbpUtil.getEnv('APP_ACCERTIFY_URL');
    const { setScriptLoaded } = useAccertifyContext();
    useEffect(() => {
        if (typeof window !== 'undefined' && !document.querySelector('#accertify-script') && DATA_COLLECTOR_URL) {
            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('src', DATA_COLLECTOR_URL);
            script.setAttribute('dvct', '500');
            script.setAttribute('id', 'bcn');
            script.setAttribute('dvc', 'a');
            script.onload = () => {
                if (window.hasOwnProperty('_bcn') && window._bcn.hasOwnProperty('dvc')) {
                    window._bcn.dvc.setSubmissionCallback(registeredCallBackMethod());
                    setScriptLoaded(true);
                }
            };
            document.head.appendChild(script);
        }
    }, []);

    return null;
};

export default AccertifyScript;
